export class VirtualPropertyBaseDefinition {}